import React, { useState, useEffect } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ListGroup,
  ListGroupItem,
  Badge,
  Spinner
} from 'reactstrap'
import { getCannedResponses } from '../../helpers/chat_helper'

const CannedResponseSelector = (props) => {
  const { onSelect, disabled } = props
  const [isOpen, setIsOpen] = useState(false)
  const [responses, setResponses] = useState([])
  const [filteredResponses, setFilteredResponses] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)

  const toggle = () => setIsOpen(!isOpen)

  useEffect(() => {
    if (isOpen) {
      loadResponses()
    }
  }, [isOpen])

  useEffect(() => {
    if (searchTerm) {
      const filtered = responses.filter(
        r =>
          r.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          r.shortcut.toLowerCase().includes(searchTerm.toLowerCase()) ||
          r.content.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setFilteredResponses(filtered)
    } else {
      setFilteredResponses(responses)
    }
  }, [searchTerm, responses])

  const loadResponses = async () => {
    try {
      setLoading(true)
      const response = await getCannedResponses({ is_active: true, limit: 100 })
      const data = response?.data?.data?.canned_responses || response?.data?.canned_responses || []
      setResponses(data)
      setFilteredResponses(data)
    } catch (error) {
      console.error('Error loading canned responses:', error)
      setResponses([])
    } finally {
      setLoading(false)
    }
  }

  const handleSelect = (response) => {
    if (onSelect) {
      onSelect(response.content)
    }
    setIsOpen(false)
    setSearchTerm('')
  }

  return (
    <>
      {props.render ? (
        props.render(toggle)
      ) : (
        <Button
          color="light"
          size="sm"
          onClick={toggle}
          disabled={disabled}
          title="Insert quick reply"
        >
          <i className="mdi mdi-lightning-bolt"></i>
        </Button>
      )}

      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Quick Replies</ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder="Search quick replies..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mb-3"
          />

          {loading ? (
            <div className="text-center py-4">
              <Spinner color="primary" />
            </div>
          ) : filteredResponses.length > 0 ? (
            <ListGroup flush style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {filteredResponses.map((response) => (
                <ListGroupItem
                  key={response.id}
                  action
                  onClick={() => handleSelect(response)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <h6 className="mb-1">
                        {response.title}
                        <Badge color="secondary" className="ms-2 small">
                          {response.shortcut}
                        </Badge>
                      </h6>
                      <p className="text-muted small mb-0">{response.content.substring(0, 100)}...</p>
                      {response.category && (
                        <Badge color="info" className="mt-1">
                          {response.category}
                        </Badge>
                      )}
                    </div>
                  </div>
                </ListGroupItem>
              ))}
            </ListGroup>
          ) : (
            <div className="text-center text-muted py-4">
              <i className="mdi mdi-lightning-bolt-outline" style={{ fontSize: '48px' }}></i>
              <p className="mt-2">No quick replies found</p>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default CannedResponseSelector
